import styles from './Avatar.module.scss';

interface AvatarProps {
  name: string;
  color?: string;
  size?: number;
}

function initials(name: string) {
  return name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0]?.toUpperCase())
    .join('');
}

export function Avatar({ name, color = '#3B82F6', size = 32 }: AvatarProps) {
  return (
    <span
      className={styles.avatar}
      style={{
        width: size,
        height: size,
        fontSize: Math.round(size * 0.42),
        ['--avatar-color' as string]: color,
      }}
      aria-label={name}
    >
      {initials(name) || '?'}
    </span>
  );
}
